module.exports = "<div class=\"c-box-list\">\n    <slot name=\"heading\"></slot>\n    <slot></slot>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/box-list/box-list.vhtml
// module id = 294
// module chunks = 0